import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TaraHeading from '../taraUI/TaraHeading';
import TaraInput from '../taraUI/TaraInput';
import { RootState } from '../../../store/store';
import '../../../styles/pages/tara/chat/taraNewChat.scss';

import TaraChatbotConnection from '../taraUI/TaraChatbotConnection';
import generateRandomString from '../../../lib/helper-functions/generateRandomString';
import { PromptBuilderModal } from '../../../components/prompt-builder/PromptBuilderModal';

type Props = {
  onCurrentChatUpdate: (chat: any) => void;
  cancelAPICall: () => void;
  loading: 'pending' | 'success' | 'error' | 'null';
};

const TaraNewChat = ({
  onCurrentChatUpdate,
  cancelAPICall,
  loading,
}: Props) => {
  const { t } = useTranslation();
  const canChatStatus = useSelector((state: RootState) => state.chat.canChat);
  const [showPromptBuilder, setShowPromptBuilder] = useState(false);

  const handleOpenPromptBuilder = () => {
    setShowPromptBuilder(true);
  };

  const handleClosePromptBuilder = () => {
    setShowPromptBuilder(false);
  };

  const handleInsertPrompt = (prompt: string) => {
    // Directly call the updateChat function to start the chat
    if (prompt.trim()) {
      onCurrentChatUpdate({
        newChatId: generateRandomString(10),
        newChat: prompt.trim(),
        role: 'user',
        messageType: 'text',
      });
    } else {
      console.error('No prompt to insert');
    }
  };

  return (
    <div className='tara tara-new'>
      <TaraHeading />
      <TaraInput
        updateChat={onCurrentChatUpdate}
        cancelAPI={cancelAPICall}
        loading={loading}
      />
      {canChatStatus && (
        <>
          {/* //* 👇🏼 Hidden for now as requested -> https://mattermost.adup.io/adup/pl/95gd3gzcepdfpqdssa3ud77p1o */}
          {/* <TaraSearchSuggestions updateChat={onCurrentChatUpdate} /> */}
          <div className='tara-help-section'>
            {t('NeedHelpSettingUpPrompt') + ' '}
            <button
              onClick={handleOpenPromptBuilder}
              className='tara-help-link'
            >
              {t('ClickHere') + ' '}
            </button>
            ✨
          </div>
        </>
      )}

      <TaraChatbotConnection />

      <PromptBuilderModal
        isOpen={showPromptBuilder}
        onClose={handleClosePromptBuilder}
        onInsertPrompt={handleInsertPrompt}
      />
    </div>
  );
};

export default TaraNewChat;
